import { LgColorLightnessIdentifier, LgColorPaletteIdentifiers } from "@logex/framework/lg-charts";

export interface IColor {
    paletteIdentifier: LgColorPaletteIdentifiers;
    lightnessIdentifier: LgColorLightnessIdentifier;
}
